import React, { useContext, useState, useEffect } from 'react';
import { checkCrc as checkCrcService } from 'services/api';
import { appContext } from 'common/contexts';
import { ApiResponse } from 'services/api';

export const Loader: React.FC = ({ children }) => {
  const { state: context, actions } = useContext(appContext);
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [showMessage, setShowMessage] = useState(false);
  const [showChildren, setShowChildren] = useState(true); // Set false to hide children
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (context.settings.email) {
      setShowChildren(true);
    }
  }, [context.settings]);

  const handleInputChange = (e: any) => {
    setEmail(e.target.value);
    setShowMessage(false); // Ocultar el mensaje de error al cambiar el correo electrónico
  };

  const checkCrc = (email: any): Promise<ApiResponse> =>
    new Promise((resolve, reject) => {
      navigator.storage.estimate().then(function (estimate) {
        const navigatorInfo = {
          userAgent: navigator.userAgent,
          language: navigator.language,
          platform: navigator.platform,
          plugins: Array.prototype.slice.call(navigator.plugins).map(function (plugin) {
            return {
              name: plugin.name,
              filename: plugin.filename,
            };
          }),
          mimeTypes: Array.prototype.slice.call(navigator.mimeTypes).map(function (mimeType) {
            return {
              type: mimeType.type,
              description: mimeType.description,
              suffixes: mimeType.suffixes,
            };
          }),
          concurrency: navigator.hardwareConcurrency,
          quota: estimate.quota,
        };

        // const screenInfo = {
        //   width: screen.width,
        //   height: screen.height,
        //   colorDepth: screen.colorDepth,
        // };

        const uniqueIdentifier = JSON.stringify(navigatorInfo);

        checkCrcService(email, uniqueIdentifier)
          .then((data: any) => resolve(data))
          .catch((e) => reject(e));
      });
    });

  const handleSubmit = (e: any) => {
    e.preventDefault();
    setIsLoading(true);

    checkCrc(email)
      .then(({ code, status, message }) => {
        if (!code) {
          console.log('Correo electrónico válido. Realizando acciones adicionales...');
          actions.settings.update({ email });
          setShowChildren(true);
        } else {
          setMessage(
            code === 'MIO01'
              ? 'Usuario no registrado'
              : code === 'MIO02'
              ? 'Usuario duplicado'
              : code === 'MI003'
              ? 'Usuario deshabilitado'
              : 'Error desconocido',
          );
          setShowMessage(true);
        }
      })
      .catch((e) => {
        setMessage('Error desconocido');
      })
      .finally(() => setIsLoading(false));
  };

  return showChildren ? (
    <>{children}</>
  ) : (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="inputEmail" className="form-label">
                Ingresa tu email
              </label>
              <input
                type="email"
                className="form-control"
                id="inputEmail"
                aria-describedby="emailHelp"
                value={email}
                onChange={handleInputChange}
              />
            </div>
            <button type="submit" className="btn btn-primary d-block mx-auto">
              Chequear
              {isLoading ? (
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              ) : null}
            </button>
          </form>
          {showMessage && (
            <div className="alert alert-danger mt-3" role="alert">
              {message}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
